import styled from 'styled-components';

import { TreeItem, TreeView } from '@mui/x-tree-view';

import { createTheme } from '@mui/material';

export const StyledTreeSelectItem = styled(TreeItem)`
  .MuiTreeItem-group {
    margin-left: 10px;
  }

  ${({ haschildren }) =>
    !haschildren &&
    `
.MuiTypography-root: {
  background: white !important;
  cursor: default;
}

.MuiTreeItem-label {
  background: white !important;
  cursor: default;
}

.MuiTreeItem-content {
  background: white !important;
  cursor: default;
}
`}
`;

export const StyleTreeSelectView = styled(TreeView)`
  .MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label:not(:hover) {
    background-color: white !important;
  }

  // .MuiTypography-root .MuiTreeItem-label .MuiTypography-body1:focus {
  //   background: white;
  // }

  .MuiTreeItem-root:focus:not(:hover) > .MuiTreeItem-content .MuiTreeItem-label {
    background-color: transparent !important;
  }
`;

export const MenuContent = styled.div`
  padding: 0 10px;
  min-width: 330px;
  min-height: 120px;
  max-height: 450px;
`;

export const MenuContentHeader = styled.div`
  display: flex;
`;

export const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          margin: 0,
          padding: 0,
        },
        'html, body, #root': {
          height: '100%',
        },
        ul: {
          listStyle: 'none',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: { verticalAlign: 'middle' },
      },
    },
  },
});
